import React from "react";
import SVG, { SVGProps } from "./SVG";

const directions = {
  up: (
    <path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"></path>
  ),
  down: (
    <path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"></path>
  ),
  left: (
    <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"></path>
  ),
  right: (
    <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"></path>
  ),
};

interface Props {
  direction?: keyof typeof directions;
}

const LineArrowIcon: React.FunctionComponent<Props & SVGProps> = ({
  direction = "right",
  ...restProps
}) => <SVG {...restProps}>{directions[direction]}</SVG>;

export default LineArrowIcon;
